/**
 * 문장 하나만 떼어낸다.
 *
 * 목록에서 긴 인용을 통째로 펼쳐두면 여섯 줄짜리가 화면을 덮어
 * 다음 문장이 눈에 들어오지 않는다. 첫 문장만 보이고 나머지는
 * 눌러서 펼친다.
 */

/** 마침표류 + 뒤따르는 닫는 기호. 뒤에 공백이나 끝이 와야 소수점을 피한다. */
const END = /[.!?…](["'”’」』)\]]*)(?=\s|$)/;

/** 문장 부호가 없을 때 이 길이를 넘으면 잘라낸다 */
const HARD = 46;

/**
 * @returns {{head: string, rest: string}} rest 가 비어 있으면 자를 게 없다
 */
export default function firstSentence(text) {
  const s = String(text ?? "").trim();
  if (!s) return { head: "", rest: "" };

  const m = END.exec(s);
  if (m) {
    const cut = m.index + m[0].length;
    // 첫 문장이 곧 전부면 자르지 않는다
    const rest = s.slice(cut).trim();
    return rest ? { head: s.slice(0, cut).trim(), rest } : { head: s, rest: "" };
  }

  // 마침표가 없는 인용도 있다. 그때는 길이로 자르되 단어를 쪼개지 않는다.
  if (s.length <= HARD) return { head: s, rest: "" };
  const sp = s.lastIndexOf(" ", HARD);
  const cut = sp > HARD * 0.5 ? sp : HARD;
  return { head: s.slice(0, cut).trim(), rest: s.slice(cut).trim() };
}
